import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'stockTag',
      type: 'input',
      label: '概念名称',
      placeholder: '请输入概念名称',
      rules: { required: true, message: '概念名称是必传的', trigger: 'blur' }
    },
    {
      field: 'content',
      type: 'input',
      label: '描述信息',
      placeholder: '请输入描述信息',
      rules: { required: true, message: '描述信息是必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
